import {
  HttpClient,
  HttpClientModule,
  HTTP_INTERCEPTORS,
} from '@angular/common/http';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
import { LoadingBarRouterModule } from '@ngx-loading-bar/router';

import { AppComponent } from './app.component';
import { AppRoutes } from './app.routing';
import { HomeComponent } from './home/home.component';
import { SharedModule } from './shared/shared.module';
import { CustomHttpInterceptor } from './utilities/CustomHttpInterceptor';
import { UtilitiesService } from './utilities/utilities.service';
import { SkuDataService } from './services/sku-data.service';
import { FilterDataService } from './services/filter-data.service';
import { AlertService } from './services/alert.service';
import { AlertComponent } from './directives/alert/alert.component';
import { environment } from 'src/environments/environment';
import { ApplicationInitializationService } from './services/application-initialization.service';

import { RoamingComponent } from './roaming/roaming.component';
import { RoamingCountriesPartnersComponent } from './roaming-countries-partners/roaming-countries-partners.component';
import { RoamingSearchModule } from './roaming-search/roaming-search.module';
import { CommonModule } from '@angular/common';
import { ParentalControlAddonsComponent } from './parental-control-addons/parental-control-addons.component';
import { ParentalControlDetailsComponent } from './parental-control-details/parental-control-details.component';
import { RoamingSearchOptionsDataService } from './services/roaming-search-options-data.service';
import { AppCmsUrlsInitializationService } from './services/app-cms-urls-initialization.service';
import { LayoutsModule } from './layouts/layouts.module';
import { AddonSubscriptionDataService } from './services/addon-subscription-data.service';
import { AddonSubscriptionService } from './services/addon-subscription.service';
import { ThankyouComponent } from './thankyou/thankyou.component';
import { ArenaProDataService } from './services/arena-pro-data.service';
@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    AlertComponent,
    RoamingComponent,
    RoamingCountriesPartnersComponent,
    ParentalControlAddonsComponent,
    ParentalControlDetailsComponent,
    ThankyouComponent
  ],
  exports: [
    HomeComponent,
    RoamingComponent
  ],
  imports: [
    BrowserModule,
    IonicModule.forRoot(),
    AppRoutes,
    SharedModule,
    CommonModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
 
    LoadingBarRouterModule,
    LoadingBarHttpClientModule,
    LayoutsModule
  ],
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CustomHttpInterceptor,
      multi: true,
    },
    { provide: 'googleTagManagerId', useValue: 'GTM-TSZ46Z' },
    UtilitiesService,
    SkuDataService,
    FilterDataService,
    AlertService,
    RoamingSearchOptionsDataService,
    { 
      provide : APP_INITIALIZER, 
      multi : true, 
      deps : [ApplicationInitializationService], 
      useFactory : (applicationInitializationService : ApplicationInitializationService) => () => applicationInitializationService.initializeApp()
    },
    { 
      provide : APP_INITIALIZER, 
      multi : true, 
      deps : [AppCmsUrlsInitializationService], 
      useFactory :(appCmsUrlsInitializationService : AppCmsUrlsInitializationService) => () => appCmsUrlsInitializationService.appCmsUrlsInitialization()
    },
    AddonSubscriptionService,
    AddonSubscriptionDataService,
    ArenaProDataService
  ],
  entryComponents:[RoamingComponent],

  bootstrap: [AppComponent],
})
export class AppModule { }

// required for AOT compilation
export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, environment.TRANSLATION_URL, '.json');
}
